import { useMemo, useState } from "react";
import AttendanceTracker from "../components/AttendanceTracker";
import TaskCard from "../components/TaskCard";

const TrainerDashboard = ({ session, users, tasks, attendance, onCreateTask }) => {
  const assignedTrainees = useMemo(
    () => users.filter((user) => user.role === "Trainee" && user.assignedTrainer === session?.id),
    [users, session]
  );
  const trainerTasks = useMemo(
    () => tasks.filter((task) => task.trainerId === session?.id),
    [tasks, session]
  );
  const traineeAttendance = attendance.filter((record) =>
    assignedTrainees.some((trainee) => trainee.id === record.userId)
  );

  const [form, setForm] = useState({
    title: "",
    description: "",
    traineeId: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  if (!session || session.role !== "Trainer") {
    return (
      <section className="dashboard dashboard-locked">
        <h2>Trainer access required</h2>
        <p>Please login as a trainer to view the task board and attendance.</p>
      </section>
    );
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onCreateTask({
      title: form.title,
      description: form.description,
      trainerId: session.id,
      traineeId: Number(form.traineeId),
    });
    setForm({ title: "", description: "", traineeId: "" });
  };

  const hasTrainees = assignedTrainees.length > 0;

  return (
    <section className="dashboard trainer-dashboard">
      <header>
        <p className="eyebrow">Trainer Zone</p>
        <h1>Mentor trainees and monitor progress.</h1>
      </header>

      <div className="dashboard-grid">
        <div className="card">
          <h3>Assigned Trainees</h3>
          <ul>
            {assignedTrainees.map((trainee) => (
              <li key={trainee.id}>{trainee.name}</li>
            ))}
            {assignedTrainees.length === 0 && <li>No trainees assigned yet.</li>}
          </ul>
        </div>
        <div className="card">
          <h3>Tasks Created</h3>
          <p className="stat">{trainerTasks.length}</p>
        </div>
      </div>

      <form className="form-card" onSubmit={handleSubmit}>
        <h3>Assign a Task</h3>
        <label>
          Title
          <input name="title" value={form.title} onChange={handleChange} required />
        </label>
        <label>
          Description
          <textarea name="description" rows="3" value={form.description} onChange={handleChange} required />
        </label>
        <label>
          Trainee
          <select
            name="traineeId"
            value={form.traineeId}
            onChange={handleChange}
            disabled={!hasTrainees}
            required
          >
            <option value="">{hasTrainees ? "Select Trainee" : "No trainees assigned yet"}</option>
            {assignedTrainees.map((trainee) => (
              <option key={trainee.id} value={trainee.id}>
                {trainee.name}
              </option>
            ))}
          </select>
        </label>
        {!hasTrainees && (
          <p className="muted small">Ask an admin to assign trainees to you before creating tasks.</p>
        )}
        <button type="submit" className="primary" disabled={!hasTrainees}>
          Create Task
        </button>
      </form>

      <div className="task-list">
        <h3>Task Status</h3>
        <div className="task-grid">
          {trainerTasks.map((task) => (
            <TaskCard key={task.id} task={task} />
          ))}
          {trainerTasks.length === 0 && <p className="muted">No tasks assigned yet.</p>}
        </div>
      </div>

      <AttendanceTracker records={traineeAttendance} title="Assigned Trainee Attendance" />
    </section>
  );
};

export default TrainerDashboard;
